module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.bannerPlaceHolderForGoForAppOnlySale) ? _c('div', {
    staticClass: "Home home-background"
  }, [(_vm.bannerPlaceHolder && _vm.bannerPlaceHolder.status) ? _c('BannerPlaceHolderMsg', {
    attrs: {
      "bannerStyle": _vm.bannerPlaceHolder && _vm.bannerPlaceHolder.styles,
      "bannerMsg": _vm.bannerPlaceHolder && _vm.bannerPlaceHolder.text
    }
  }) : _vm._e(), _vm._v(" "), _c('div', [(_vm.homeLandingBanners && _vm.homeLandingBanners.length) ? _c('div', [(_vm.isDesktop) ? _c('div', {
    staticClass: "headtop prelative"
  }, [_c('carousel', {
    ref: "my-carousel",
    staticClass: "bannerview",
    attrs: {
      "perPage": 1,
      "navigationEnabled": true,
      "paginationEnabled": true,
      "navigationNextLabel": " ",
      "navigationPrevLabel": " ",
      "loop": true,
      "autoplay": true,
      "paginationPadding": 7,
      "autoplayTimeout": 6000,
      "speed": 500,
      "paginationActiveColor": "#117a7a"
    },
    on: {
      "pageChange": _vm.bannerPageEventHandler
    }
  }, _vm._l((_vm.homeLandingBanners), function(bimg, index) {
    return _c('slide', {
      key: index
    }, [_c('div', {
      staticClass: "prelative shimmerBgColor",
      on: {
        "click": function($event) {
          _vm.triggerCarouselEvents(index, bimg)
        }
      }
    }, [(_vm.getExtension(bimg.image) === 'mp4') ? _c('div', [_c('a', {
      attrs: {
        "href": bimg.link,
        "title": bimg.alt
      }
    }, [_c('video', {
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "autoplay": {
          true: _vm.getExtension(bimg.image) === 'mp4'
        }
      }
    }, [_c('source', {
      attrs: {
        "data-src": _vm.isComboActive ? _vm.getHomeBannerImage(bimg.image) : _vm.htpath + bimg.image,
        "type": "video/mp4"
      }
    }), _vm._v("\n                      Your browser does not support the video tag.\n                    ")])])]) : _c('div', {
      staticClass: "shimmerBgColor"
    }, [(bimg.navigation_link) ? _c('a', {
      staticClass: "clickable d-inline-block w-100",
      attrs: {
        "href": _vm.getUrl(bimg.navigation_link),
        "target": bimg.navigation_link === 'https://view.gmetri.com' && _vm.authStatus ? '_blank' : '_self',
        "aria-label": bimg.promotion_name || 'Home Banner'
      }
    }, [_c('img', {
      staticClass: "w-100  img-auto",
      attrs: {
        "loading": index <= 1 ? 'eager' : 'lazy',
        "src": _vm.isComboActive ? _vm.getHomeBannerImage(bimg.image) : _vm.htpath + bimg.image,
        "alt": bimg.alt || bimg.title || 'Home Banner',
        "width": "1500",
        "height": "512"
      },
      on: {
        "load": function($event) {
          _vm.loadimage($event)
        }
      }
    })]) : _c('router-link', {
      attrs: {
        "to": bimg.link ? bimg.link : '',
        "aria-label": bimg.promotion_name || 'Home Banner'
      }
    }, [_c('img', {
      staticClass: "w-100  img-auto",
      attrs: {
        "loading": index <= 1 ? 'eager' : 'lazy',
        "src": _vm.isComboActive ? _vm.getHomeBannerImage(bimg.image) : _vm.htpath + bimg.image,
        "alt": bimg.alt || bimg.title || 'Home Banner',
        "width": "1500",
        "height": "512"
      },
      on: {
        "load": function($event) {
          _vm.loadimage($event)
        }
      }
    })])], 1), _vm._v(" "), (bimg.is_split_banner && (bimg.navigation_link || bimg.right_navigation_link)) ? _c('div', {
      staticClass: "row splitted-navigation-container"
    }, [_c('a', {
      staticClass: "col-6",
      attrs: {
        "href": _vm.getUrl(bimg.navigation_link),
        "target": bimg.navigation_link === 'https://view.gmetri.com' && _vm.authStatus ? '_blank' : '_self'
      }
    }), _vm._v(" "), _c('a', {
      staticClass: "col-6",
      attrs: {
        "href": _vm.getUrl(bimg.right_navigation_link),
        "target": bimg.right_navigation_link === 'https://view.gmetri.com' && _vm.authStatus ? '_blank' : '_self'
      }
    })]) : (bimg.is_split_banner && (bimg.link || bimg.right_link)) ? _c('div', {
      staticClass: "row splitted-navigation-container"
    }, [_c('router-link', {
      staticClass: "col-6",
      attrs: {
        "to": bimg.link ? bimg.link : ''
      }
    }), _vm._v(" "), _c('router-link', {
      staticClass: "col-6",
      attrs: {
        "to": bimg.right_link ? bimg.right_link : ''
      }
    })], 1) : _vm._e()])])
  }))], 1) : _c('div', {
    staticClass: "headtop prelative"
  }, [_c('carousel', {
    ref: "my-carousel",
    class: _vm.isDesktop ? 'bannerview' : 'mobileBannerView',
    attrs: {
      "perPage": 1,
      "navigationEnabled": true,
      "paginationEnabled": true,
      "navigationNextLabel": " ",
      "navigationPrevLabel": " ",
      "autoplay": true,
      "paginationPadding": 1,
      "autoplayTimeout": 4000,
      "speed": 500,
      "loop": true,
      "paginationSize": 6,
      "paginationColor": '#979a9f'
    },
    on: {
      "pageChange": _vm.bannerPageEventHandler
    }
  }, _vm._l((_vm.homeLandingBanners), function(bimg, index) {
    return _c('slide', {
      key: index
    }, [_c('div', {
      directives: [{
        name: "bannerImageLoad",
        rawName: "v-bannerImageLoad",
        value: (_vm.getBannerImpressionData(bimg, index)),
        expression: "getBannerImpressionData(bimg, index)"
      }],
      staticClass: "prelative shimmerBgColor",
      on: {
        "click": function($event) {
          _vm.triggerCarouselEvents(index, bimg)
        }
      }
    }, [(bimg.navigation_link) ? _c('a', {
      staticClass: "d-inline-block w-100 clickable",
      attrs: {
        "href": _vm.getUrl(bimg.navigation_link),
        "target": bimg.navigation_link === 'https://view.gmetri.com' && _vm.authStatus ? '_blank' : '_self'
      }
    }, [(_vm.bannerPlaceHolderForCarouselSize) ? _c('img', {
      staticClass: "w-100  img-h-auto",
      attrs: {
        "loading": index <= 1 ? 'eager' : 'lazy',
        "src": _vm.isComboActive ? _vm.getHomeBannerImage(bimg.mobile_image) : _vm.htpath + bimg.mob_image,
        "alt": bimg.alt || bimg.title || 'Home Banner',
        "width": "375",
        "height": "482"
      },
      on: {
        "load": function($event) {
          _vm.loadimage($event)
        }
      }
    }) : _vm._e(), _vm._v(" "), (!_vm.bannerPlaceHolderForCarouselSize) ? _c('img', {
      staticClass: "w-100  img-h-auto",
      attrs: {
        "loading": index <= 1 ? 'eager' : 'lazy',
        "src": _vm.isComboActive ? _vm.getHomeBannerImage(bimg.mobile_image) : _vm.htpath + bimg.mob_image,
        "alt": bimg.alt || bimg.title || 'Home Banner',
        "width": "768",
        "height": "600"
      },
      on: {
        "load": function($event) {
          _vm.loadimage($event)
        }
      }
    }) : _vm._e()]) : _c('router-link', {
      staticClass: "d-inline-block w-100",
      attrs: {
        "to": bimg.link ? bimg.link : ''
      }
    }, [(_vm.bannerPlaceHolderForCarouselSize) ? _c('img', {
      staticClass: "w-100  img-h-auto",
      attrs: {
        "loading": index <= 1 ? 'eager' : 'lazy',
        "src": _vm.isComboActive ? _vm.getHomeBannerImage(bimg.mobile_image) : _vm.htpath + bimg.mob_image,
        "alt": bimg.alt || bimg.title || 'Home Banner',
        "width": "375",
        "height": "482"
      },
      on: {
        "load": function($event) {
          _vm.loadimage($event)
        }
      }
    }) : _vm._e(), _vm._v(" "), (!_vm.bannerPlaceHolderForCarouselSize) ? _c('img', {
      staticClass: "w-100  img-h-auto",
      attrs: {
        "loading": index <= 1 ? 'eager' : 'lazy',
        "src": _vm.isComboActive ? _vm.getHomeBannerImage(bimg.mobile_image) : _vm.htpath + bimg.mob_image,
        "alt": bimg.alt || bimg.title || 'Home Banner',
        "width": "768",
        "height": "600"
      },
      on: {
        "load": function($event) {
          _vm.loadimage($event)
        }
      }
    }) : _vm._e()]), _vm._v(" "), (bimg.is_split_banner && (bimg.navigation_link || bimg.right_navigation_link)) ? _c('div', {
      staticClass: "row splitted-navigation-container"
    }, [_c('a', {
      staticClass: "col-6",
      attrs: {
        "href": _vm.getUrl(bimg.navigation_link),
        "target": bimg.navigation_link === 'https://view.gmetri.com' && _vm.authStatus ? '_blank' : '_self'
      }
    }), _vm._v(" "), _c('a', {
      staticClass: "col-6",
      attrs: {
        "href": _vm.getUrl(bimg.right_navigation_link),
        "target": bimg.right_navigation_link === 'https://view.gmetri.com' && _vm.authStatus ? '_blank' : '_self'
      }
    })]) : (bimg.is_split_banner && (bimg.link || bimg.right_link)) ? _c('div', {
      staticClass: "row splitted-navigation-container"
    }, [_c('router-link', {
      staticClass: "col-6",
      attrs: {
        "to": bimg.link ? bimg.link : ''
      }
    }), _vm._v(" "), _c('router-link', {
      staticClass: "col-6",
      attrs: {
        "to": bimg.right_link ? bimg.right_link : ''
      }
    })], 1) : _vm._e()], 1)])
  }))], 1)]) : _vm._e(), _vm._v(" "), (_vm.timerData.showCountDown && true) ? _c('Countdown', {
    attrs: {
      "starttime": _vm.timerData.startDate,
      "endtime": _vm.timerData.endDate,
      "color": _vm.timerData.timerColor,
      "showTimer": _vm.timerData.showTimer,
      "pretext": _vm.timerData.liveSaleText,
      "mobileUI": _vm.isDesktop ? false : true,
      "showEarlyText": _vm.timerData.showEarlyText
    },
    on: {
      "getLiveSaleText": _vm.getSaleTextToShow
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), (_vm.keepExploringData && Object.keys(_vm.keepExploringData).length && _vm.isShowOnlyKeepExploringWidget) ? _c('div', {
    staticClass: "fullWidth categorySection"
  }, _vm._l((_vm.keepExploringData), function(item, key, index) {
    return _c('HomeWidgetsWrapper', {
      key: index,
      attrs: {
        "bannerPlaceHolderForFireWorkStoryBlock": _vm.bannerPlaceHolderForFireWorkStoryBlock,
        "bannerPlaceHolderForFireWorkGrid": _vm.bannerPlaceHolderForFireWorkGrid,
        "widgetType": _vm.getType(item)
      }
    }, [_c(_vm.getComponetToRender(item, key), {
      tag: "component",
      attrs: {
        "renderName": item && item[item.length - 1] && item[item.length - 1].length >= 3 && item[item.length - 1][2],
        "renderData": item,
        "isWidgetProduct": true,
        "homepath": _vm.homepath,
        "widgetType": _vm.getType(item),
        "callerComp": "homePage"
      }
    })], 1)
  })) : _vm._e(), _vm._v(" "), (_vm.homeLandingWidgets && Object.keys(_vm.homeLandingWidgets).length) ? _c('div', {
    staticClass: "fullWidth categorySection"
  }, _vm._l((_vm.homeLandingWidgets), function(item, key, index) {
    return _c('HomeWidgetsWrapper', {
      key: index,
      attrs: {
        "bannerPlaceHolderForFireWorkStoryBlock": _vm.bannerPlaceHolderForFireWorkStoryBlock,
        "bannerPlaceHolderForFireWorkGrid": _vm.bannerPlaceHolderForFireWorkGrid,
        "widgetType": _vm.getType(item)
      }
    }, [_c(_vm.getComponetToRender(item, key), {
      tag: "component",
      attrs: {
        "renderName": item && item[item.length - 1] && item[item.length - 1].length >= 3 && item[item.length - 1][2],
        "renderData": item,
        "homepath": _vm.homepath,
        "widgetType": _vm.getType(item),
        "callerComp": "homePage"
      }
    })], 1)
  })) : _vm._e()], 1), _vm._v(" "), _c('script', {
    attrs: {
      "type": "application/ld+json"
    }
  }, [_vm._v("\n    {\n      \"@context\": \"http://schema.org\",\n      \"@type\": \"Corporation\",\n      \"name\": \"The Souled Store\",\n      \"legalName\" : \"The Souled Store\",\n      \"description\": \"We, at The Souled Store, love what we do- designs, products, marketing, and everything in between. Our goal is to give everyone something they'll love, something they can use to express themselves, and, simply put, something to put a smile on their face.\",\n      \"url\": \"https://www.thesouledstore.com/\",\n      \"logo\": \"https://www.thesouledstore.com//static/img/newlogo.8dcc6cc.png\",\n      \"foundingDate\": \"2013\",\n      \"foundingLocation\": \"Mumbai\",\n      \"address\": {\n        \"@type\": \"PostalAddress\",\n        \"streetAddress\": \"224, Tantia Jogani Industrial Premises Opp Lodha Excelus, Jivraj Ramji Boricha Marg, Lower Parel East, Mumbai, Maharashtra\",\n        \"addressLocality\": \"Lower Parel East\",\n        \"addressRegion\": \"Mumbai, Maharashtra\",\n        \"postalCode\": \"400011, IN\",\n        \"addressCountry\": \"India\"\n      },\n      \"contactPoint\": {\n        \"@type\": \"ContactPoint\",\n        \"contactType\": \"customer support\",\n        \"telephone\": \"022 68493328\",\n        \"email\": \"connect@thesouledstore.com\",\n        \"hoursAvailable\": \"Mon to Fri: 09.30 am to 10.00 pm, Sat-Sun: 09.30 am to 7.00 pm\"\n      },\n\n      \"sameAs\": [\n        \"https://www.linkedin.com/company/the-souled-store-pvt-ltd-/about/\",\n        \"https://www.instagram.com/TheSouledStore/\",\n        \"https://www.facebook.com/souledstore/\",\n        \"https://twitter.com/TheSouledStore\",\n        \"https://www.youtube.com/channel/UC1LkdB8GTrMEwFF_yzqytoA\",\n        \"https://www.crunchbase.com/organization/the-souled-store\"\n      ]\n}\n  ")]), _vm._v(" "), _c('script', {
    attrs: {
      "type": "application/ld+json"
    }
  }, [_vm._v("\n{\n    \"@context\": \"https://schema.org\",\n    \"@type\": \"WebSite\",\n    \"url\": \"https://www.thesouledstore.com/\",\n    \"potentialAction\": [{\n    \"@type\": \"SearchAction\",\n    \"target\": \"https://www.thesouledstore.com/search?q={search_term_string}\",\n    \"query-input\": \"required name=search_term_string\"\n  }]\n}\n")])], 1) : _c('div', {
    directives: [{
      name: "dynamic-min-height",
      rawName: "v-dynamic-min-height"
    }],
    staticClass: "goForAppNlySale-wrapper"
  }, [_c('div', {
    staticClass: "headtop prelative"
  }, _vm._l((_vm.AppLandingBanners), function(bimg, index) {
    return _c('div', {
      key: index
    }, [_c('div', {
      directives: [{
        name: "dynamic-min-height",
        rawName: "v-dynamic-min-height"
      }],
      staticClass: "prelative"
    }, [_c('router-link', {
      attrs: {
        "to": bimg.url ? bimg.url : '',
        "aria-label": bimg.promotion_name || 'Home Banner'
      }
    }, [_c('img', {
      attrs: {
        "data-src": _vm.isDesktop ? bimg.image : bimg.mobile_image,
        "alt": bimg.name || 'TSS Banner'
      }
    }), _vm._v(" "), (bimg.is_viewmore_button_visible) ? _c('div', {
      staticClass: "show-more-btn"
    }, [_c('span', {
      staticClass: "show-more-btn-txt"
    }, [_vm._v(_vm._s(bimg.name))])]) : _vm._e()]), _vm._v(" "), (bimg.is_split_banner) ? _c('div', {
      staticClass: "row splitted-navigation-container"
    }, [_c('div', {
      staticClass: "col-6 pointer",
      attrs: {
        "aria-label": "left url"
      },
      on: {
        "click": function($event) {
          _vm.appOpenHandler('Play Store')
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "col-6 pointer",
      attrs: {
        "aria-label": "right url"
      },
      on: {
        "click": function($event) {
          _vm.appOpenHandler('App Store')
        }
      }
    })]) : _vm._e()], 1)])
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-006a1990"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home.vue
// module id = 881
// module chunks = 117